import { styled } from '@mui/material';

export const MarkerSourceImportContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  marginBottom: '5px',
});

export const MarkerSourceImportImage = styled('img')(({ theme }) => ({
  width: 25,
  height: 25,
  borderRadius: '50%',
  backgroundColor: theme.palette.common.black,
  zIndex: 1,
}));

export const MarkerSourceImportArrow = styled('span')(({ theme }) => ({
  overflow: 'hidden',
  position: 'absolute',
  width: 15.5,
  height: 11,
  boxSizing: 'border-box',
  color: theme.palette.common.black,
  bottom: 0,
  left: '50%',
  transform: 'translate(-50%, -2px)',
  marginBottom: '-10px',

  '&::before': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: 'currentColor',
    transform: 'rotate(45deg)',
    transformOrigin: '100% 0',
  },
}));
